export default __webpack_public_path__ + "media/images/images/flags/fl-6473eb7cd0a7868e645c51188face520.png";